import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { CostoEnvio } from './costo-envio.model';

@Injectable()
export class CostoEnvioResolver implements Resolve<CostoEnvio> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(CostoEnvio);
      }
      return await this.backendService.get(CostoEnvio, CostoEnvio.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/costos-envio']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio.resolver.ts